/** 找回登录密码弹窗（→ 登录弹窗内"忘记密码?"入口） */
export const useForgotPasswordNav = () => {
  const open = useState('forgot-password-drawer-open', () => false)
  /** 从登录弹窗带入的用户名，用于预填找回密码第一步的账号输入框 */
  const prefillAccount = useState('forgot-password-prefill-account', () => '')

  const openForgotPassword = (account?: string) => {
    prefillAccount.value = account ?? ''
    open.value = true
  }

  const closeForgotPassword = () => {
    open.value = false
  }

  return { open, prefillAccount, openForgotPassword, closeForgotPassword }
}
